import PropTypes from 'prop-types';
import React from 'react';

import Icon from '@ontruck/ontruck-react-components/lib/Icon';

import style from './style.module.scss';

const StatusIcon = ({ isActive = () => true, isBlocked = () => false, className }) =>
  isBlocked() ? (
    <span className={className}>
      <Icon name="blocked" className={style.blockedIcon} />
    </span>
  ) : !isActive() ? (
    <span className={className}>
      <span className={style.circleIcon} />
    </span>
  ) : null;

StatusIcon.propTypes = {
  isActive: PropTypes.func,
  isBlocked: PropTypes.func,
  className: PropTypes.string,
};

export default StatusIcon;
